<div class="toast">
    <div class="message">
        {{message}}
    </div>
    <button
            *ngIf="!!_onClickAction"
            class="action-button"
            (click)="onClickAction()"
    >
        {{'action_message.action_button' | translate}}
    </button>
    <svg-icon
            class="close-button"
            src="./assets/icons/close.svg"
            (click)="remove()"
    ></svg-icon>
</div>
